import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { EnvironmentCopyPageContext, EnvironmentCopyPageInitialState } from ".";

export const EnvironmentCopyPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(EnvironmentCopyPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <EnvironmentCopyPageContext.Provider value={context}>
      {children}
    </EnvironmentCopyPageContext.Provider>
  );
};
